export default "__VITE_ASSET__FSkoXnRq__"